import React, { Dispatch, useState } from 'react'
import { RunModType, useRunMode } from '../../context/RunModeContext';

type ToggleSwitchPropsType = {
	width: number;
	leftLabel?: string;
	rightLabel?: string;
	backgroundColor?: string;
	switchColor?: string;
	leftActiveColor?: string;
	rightActiveColor?: string;
}

const ToggleSwitch = (props: ToggleSwitchPropsType) => {

	const { mode, setRunMode } = useRunMode()

	// Handle onclick in switch head
	const handleSwitchHeadClick = (mode: RunModType) => {

		// if (mode === 'PRODUCTION')
		// {
		// 	setRunMode('TEST')
		// }
		// else if (mode === 'TEST')
		// {
		// 	setRunMode('PRODUCTION')
		// }
	}

	return (
		<div className='switch-wrapper'>
			{props.leftLabel && (
				<span className='left-label' style={{color: mode === 'PRODUCTION' ? 'var(--color-text)' : 'gray'}}>{props.leftLabel}</span>
			)}
			<div className='toggle-switch-wrapper' style={{width: `${props.width}rem`, borderRadius: `${props.width / 0.5}rem`, backgroundColor: props.backgroundColor ? `${props.backgroundColor}` : '#ffffff'}} onClick={() => handleSwitchHeadClick(mode)}>
				<div className={`switch-head ${mode === 'TEST' ? 'right' : mode === 'PRODUCTION' ? 'left' : 'left'}`} style={{height: `${props.width / 2}rem`, backgroundColor: props.leftActiveColor && mode === 'TEST' ? `${props.leftActiveColor}` : props.leftActiveColor && mode === 'PRODUCTION' ? `${props.rightActiveColor}` : '#525ee2'  }}></div>
			</div>
			{props.rightLabel && (
				<span className='right-label' style={{color: mode === 'TEST' ? 'var(--color-text)' : 'gray'}}>{props.rightLabel}</span>
			)}
		</div>
		
  	)
}

export default ToggleSwitch